
/* eslint-disable */
import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import styled from 'styled-components'
import apiInstance from '../../../../utils/api'
import { useState, useEffect } from 'react'
import {
    Redirect,
    useLocation,
    Link,
    Navigate,
    useNavigate
} from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import SideBar from '../../SideBar'
import { FaArrowLeft } from 'react-icons/fa'

import { useSelector } from 'react-redux'

export default function MedicineUpdate() {
    // const token = localStorage.getItem('token')
    // const url = 'http://clinicdenovobackend.kwintechnologies.com:3000/apiInstance/'
    // const apiInstance = axios.create({
    //   baseURL: url,
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     'Content-Type': 'application/json'
    //   }
    // })
    const navigate = useNavigate()
    const [category, setCategory] = useState('')

    const [subCategory, setSubCategory] = useState('')
    const [upCat, setUpCat] = useState('')
    const [upSubCat, setUpSubCat] = useState('')

    const [categoryID, setCategoryID] = useState('')
    const [subCategoryID, setSubCategoryID] = useState('')

    const [categoryLists, setCategoryLists] = useState([])
    const [subCategoryLists, setSubCategoryLists] = useState([])

    const [medicineLists, setMedicineLists] = useState([])
    const [relatedBrandList, setRelatedBrandList] = useState([])
    const [upRelatedBrand, setUpRelatedBrand] = useState('')
    const [upCode, setUpCode] = useState('')
    const [upName, setUpName] = useState('')
    const [upDesc, setUpDesc] = useState('')
    const [showUpdate, setShowUpdate] = useState(false)
    const [upRelatedBrandID, setUpRelatedBrandID] = useState('')

    const [description, setDescription] = useState('')
    const ReagentId = useLocation().pathname.split('/')[2]

    const ReagentUpdate = () => {
        const data = {
            id: ReagentId,
            name: upName,
            code: upCode,
            //   relatedBrand: upRelatedBrand,
            description: upDesc
        }

        //category

        if (categoryID) {
            data.relatedCategory = categoryID
        } else {
            data.relatedCategory = category
        }



        // alert(JSON.stringify(data))
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        apiInstance
            .put('reagent-list', data, config)
            .then(function (response) {
                Swal.fire({
                    title: 'Successful!',
                    text: 'You Updated Data!',
                    icon: 'success',
                    // showCancelButton: true,

                    showConfirmButton: false,
                    timer: 2000
                })
                // window.location.reload()

                setMedicineLists([...medicineLists, response.data.data])
                navigate('/reagent')
                // setMedicineLists(
                //     medicineLists.map(category => {
                //         if (category._id === response.data.list[0]._id) {
                //             return response.data.list[0]
                //         } else {
                //             return category
                //         }
                //     })
                // )
            })
            .catch(function (err) {
                Swal.fire({
                    title: 'Something Wrong!',
                    text: 'Try again, Please.',
                    icon: 'warning',
                    // showCancelButton: true,

                    cancelButtonText: 'Close'
                })
            })
    }

    useEffect(() => {
        const getCategory = async () => {
            try {
                const res = await apiInstance.get('reagent-category')

                setCategoryLists(res.data.data)
            } catch (err) { }
        }

        const getMainReagent = async () => {
            try {
                const res = await apiInstance.get('reagent-list/' + ReagentId)
                console.log(res.data.data)
                setUpCode(res.data.data.code)
                setUpName(res.data.data.name ? res.data.data.name : '')
                setUpDesc(res.data.data.description)

                setUpCat(
                    res.data.data.relatedCategory
                        ? res.data.data.relatedCategory.name
                        : ''
                )
                setCategoryID(
                    res.data.data.relatedCategory
                        ? res.data.data.relatedCategory._id
                        : ''
                )

                // console.log(res.data.data.relatedBrand._id)
            } catch (err) {
                alert(err.message)
            }
        }

        getCategory()

        getMainReagent()

    }, [])
    return (
        <div classNameName='App'>
            {/* <!-- end preloader --> */}
            {/* @include('sweet::alert') */}

            <div className='wrapper'>
                {/* <!-- Navbar --> */}
                {/* <HeaderName /> */}

                {/* <!-- /.navbar --> */}

                {/* <!-- Main Sidebar Container --> */}
                <SideBar />

                {/* <!-- Content Wrapper. Contains page content --> */}

                <div className='content-wrapper'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-12'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/reagent'>
                                                <i>
                                                    <FaArrowLeft />
                                                </i>
                                            </Link>
                                        </li>
                                        <li className='breadcrumb-item active'>Reagent Update</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}

                    <section className='content'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='card'>
                                        <div className='card-body'>
                                            <div className='col-md-12'>
                                                <h3 className='card-header mb-4 fw-5 text-secondary py-3'>
                                                    Update
                                                </h3>
                                                <div class='modal-body'>
                                                    <div class='form-group'>
                                                        <label for='code'>Code</label>
                                                        <input
                                                            type='text'
                                                            class='form-control border border-info'
                                                            name='code'
                                                            defaultValue={upCode}
                                                            onChange={e => setUpCode(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class='form-group'>
                                                        <label for='name'>Name</label>
                                                        <input
                                                            type='text'
                                                            class='form-control border border-info'
                                                            name='name'
                                                            defaultValue={upName}
                                                            onChange={e => setUpName(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class='form-group'>
                                                        <label for='name'>Category</label>
                                                        <select
                                                            class='custom-select border-info'
                                                            name='account_type_id'
                                                            id='cat'
                                                            onChange={e => {
                                                                setCategory(e.target.value)
                                                                setCategoryID(e.target.value)
                                                            }}
                                                        >
                                                            <option value={categoryID} hidden>
                                                                {upCat}
                                                            </option>
                                                            {categoryLists.map(option => (
                                                                <option value={option._id}>
                                                                    {option.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div class='form-group'>
                                                        <label for='name'>Description</label>
                                                        <textarea
                                                            className='form-control'
                                                            id='description'
                                                            defaultValue={upDesc}
                                                            onChange={e => setUpDesc(e.target.value)}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div class='modal-footer'>
                                                    <Link
                                                        to='/reagent'
                                                        class='btn btn-secondary'
                                                        data-dismiss='modal'
                                                    >
                                                        Close
                                                    </Link>
                                                    <button
                                                        class='btn btn-primary'
                                                        onClick={ReagentUpdate}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<!-- /.container-fluid --> */}
                    </section>
                </div>
            </div>

            {/* <!-- /.content-wrapper --> */}
            <footer className='main-footer mt-5'>
                <strong>
                    Copyright &copy; 2017-2020{' '}
                    <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
                </strong>
                All rights reserved.
            </footer>
        </div>
    )
}
